import { useEffect, useState } from "react";
import { Phone } from "lucide-react";
import { PHONE_HREF, PHONE_DISPLAY, trackPhoneCall } from "@/lib/contact";

/**
 * Floating neon-green phone button — sits in the bottom-right of the viewport
 * after the visitor scrolls past the hero (~250px). One-tap dials the number.
 */
export default function StickyCallCta() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 250);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <a
      href={PHONE_HREF}
      onClick={trackPhoneCall}
      aria-label={`Call ${PHONE_DISPLAY}`}
      title={`Call ${PHONE_DISPLAY}`}
      data-testid="sticky-call-cta"
      className={`fixed z-40 bottom-[max(env(safe-area-inset-bottom),1.25rem)] right-5 md:right-7 inline-flex items-center justify-center h-14 w-14 md:h-16 md:w-16 rounded-full bg-[#FE7200] text-black shadow-[0_10px_40px_rgba(254,114,0,0.55),0_0_60px_rgba(254,114,0,0.35)] active:scale-95 hover:scale-110 hover:bg-[#FF8C2E] transition-all duration-300 ease-out ${
        visible
          ? "opacity-100 translate-y-0 pointer-events-auto"
          : "opacity-0 translate-y-6 pointer-events-none"
      }`}
    >
      {/* outer pulsing ring */}
      <span aria-hidden className="absolute inset-0 rounded-full bg-[#FE7200] opacity-50 animate-ping" />
      {/* inner glow ring */}
      <span aria-hidden className="absolute inset-[-4px] rounded-full ring-2 ring-[#FE7200]/40" />
      <Phone className="relative h-6 w-6 md:h-7 md:w-7" strokeWidth={2.5} />
    </a>
  );
}
